<template>
    <!-- Template code goes here. Remember that a template always has to have 1 main wrapper, that is why we start with an empty div. -->
    <div class="cookie-popup-wrapper" :style="{ background: darknessPercentage }">
        <div class="cookie-wrapper flex flex-align-end">
            <div class="cookie-img flex-1 align-center">
                <img src="http://www.stickpng.com/assets/images/5874ebb242e4d62873855a53.png">
            </div>
            <div class="cookie-content flex-5 flex-child-center-vertical">
                <h3 class="bold-text">We use cookies.</h3>
                <p class="light-text small-text">To ensure a smooth and most exciting experience, we use cookies. This way we can give you relevant content that is specially catered for you. Because you wouldn't want to see unrelevant content, right? <i>*Cough, Facebook, Cough*</i></p>
                <div class="consent-items flex">
                    <div class="consent-items-wrapper">
                        <template v-for="(consentItem, key) in consentItems">
                            <div class="consent-item relative inline-block" :class="{'checked-item' : consentItem.active, 'required-item' : consentItem.required, 'highlight-check-all' : highlightCheckAll}">
                                <input :key="consentItem.id" :id="key" class="cbx-box hidden" :checked="consentItem.active" type="checkbox" />
                                <label @click.prevent="handleCheckbox(consentItem)" class="cbx" :for="key"></label>
                                <label @click.prevent="handleCheckbox(consentItem)" class="lbl" :for="key">{{ consentItem.name }}</label>
                                <i @click="toggleInfo(consentItem)" class="fal fa-question-circle extra-light-text " :class="{'open-info-box' : consentItem.showInfo}"></i>
                                <!-- required item message, we probably won't be using this anymore
                                <transition name="fade">
                                    <div class="required-message " @click="toggleRequiredPopup(consentItem)" v-if="consentItem.required && consentItem.showRequired">
                                        <i class="far fa-times extra-light-text absolute"></i>
                                        <p class="light-text">This cookie is required in order for the website to function properly, and thus cannot be disabled!</p>
                                    </div>
                                </transition>
                                -->
                                <transition name="fade">
                                    <div class="required-message info-box " @click="toggleInfo(consentItem)" v-if="consentItem.showInfo">
                                        <i class="far fa-times extra-light-text absolute"></i>
                                        <div class="info-wrapper">
                                            <div class="info-item" v-for="info in consentItem.consentInfo">
                                                <p class="light-text small-text bold-text">{{ info.title }}</p>
                                                <p class="light-text tiny-text">{{ info.desc }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </template>
                        <div class="consent-item inline-block check-all relative" :class="{'highlight-check-all': highlightCheckAll}">
                            <input id="checkAll" class="cbx-box hidden" :checked="allBoxesCheckboxStatus" type="checkbox" />
                            <label @click.prevent="checkAllBoxes" class="cbx" for="checkAll"></label>
                            <label @click.prevent="checkAllBoxes" class="lbl" for="checkAll">Check all boxes</label>
                            <div class="check-all-highlight"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cookie-submit flex-1 align-center">
                <div class="general-button inline-button relative" @click="validatePopup" :class="{'animate-button': completeState}">
                    <p>To the content!</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState ,mapGetters } from 'vuex';
    import forEach from 'lodash.foreach';

    import CookieMixin from '../../mixins/CookieMixin.js';

    export default {
        mixins: [CookieMixin],
        name: 'simple-bottom',

        computed: {
            //mapState can be used to quickly get values from the state
            ...mapState('cookiepopup',
                ['consentItems',
                    'completeState',
                    'allBoxesCheckboxStatus',
                    'backgroundDarkness',
                    'highlightCheckAll']
            ),

            ...mapGetters('cookiepopup',
                ['allItemsActive',
                    'unrequiredItemsCount',
                    'unrequiredActiveCount',
                    'requiredInactive']
            ),

            darknessPercentage: function() {
                let darknessReduction = 0.75;

                if(this.unrequiredActiveCount > 0) {
                    let darknessPerItem = 0.3 / this.unrequiredItemsCount;
                    darknessReduction = darknessPerItem * this.unrequiredActiveCount;
                    darknessReduction = 0.75 - darknessReduction;
                }

                let darkness = 'rgba(0, 0, 0, ' + darknessReduction + ')';

                return darkness;
            }
        },

        methods: {
            handleCheckbox(item) {
                //if checkbox is not a required one
                //if(item.required === false) {
                //change the 'checked' value
                this.$store.commit('cookiepopup/toggleCheckbox', item);

                //hide all required messages
                this.$store.commit('cookiepopup/toggleRequiredPopup');

                //see if all checkboxes are checked
                this.checkFinished();
                //} else {
                //show popup that it is a required one
                //this.toggleRequiredPopup(item);

                //}
            },

            toggleRequiredPopup(item) {
                this.$store.commit('cookiepopup/toggleRequiredPopup', item);
            },

            checkAllBoxes() {
                if(this.allBoxesCheckboxStatus === false) {
                    this.$store.commit('cookiepopup/checkAllBoxes', true);

                    this.checkFinished();
                }
            },

            checkFinished() {
                //if all items are checked
                if(this.allItemsActive.length === this.consentItems.length) {
                    //set completeState to true
                    this.$store.commit('cookiepopup/setCompletionStatus', true);
                    this.$store.commit('cookiepopup/checkAllBoxes', true);
                } else {
                    //else, set completeState to false
                    this.$store.commit('cookiepopup/setCompletionStatus', false);

                    if(this.allBoxesCheckboxStatus === true) {
                        this.$store.commit('cookiepopup/checkAllBoxes', false);
                    }
                }
            },

            toggleInfo(item) {
                this.$store.commit('cookiepopup/toggleInfo', item);
            },

            validatePopup() {
                var self = this;

                //check if there are any required consent items that are inactive
                if(this.requiredInactive.length > 0) {
                    //open the required info box for each one
                    forEach(this.requiredInactive, function(item) {
                        self.$store.commit('cookiepopup/toggleRequiredPopup', item);
                    });

                    //highlight the check all
                    this.$store.commit('cookiepopup/setCheckAllHighlight', true);
                } else {
                    //if not, set the cookie
                    this.acceptCookie('advanced');
                }
            }
        }
    }
</script>

<style lang="scss">
    .cookie-popup-wrapper {
        transition: background 0.3s ease-in-out;
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 9999;
        top: 0;
        bottom: -100px;

        .cookie-wrapper {
            box-shadow: 0 -5px 5px -5px #565656;
            position: fixed;
            width: 100%;
            background: #fff;
            bottom: 0px;
            padding-top: 30px;
            padding-bottom: 30px;
            padding-left: 15px;
            padding-right: 15px;

            .cookie-img {
                margin-bottom: -77px;
                transform: rotateY(180deg);
                margin-top: -71px;

                img {
                    max-width: 210px;
                    filter: drop-shadow(4px 0px 3px rgba(0, 0, 0, 0.2));
                    margin-bottom: -46px;
                }
            }

            .cookie-content {
                padding-left: 20px;

                h3 {
                    font-size: 22px;
                    color: #545454;
                }

                p {
                    max-width: 80%;
                    margin-top: 15px;
                    line-height: 23px;
                }
            }
        }

        &.gray-filter {
            background: rgba(0, 0, 0, 0.75);
        }

        .consent-items {
            margin-top: 20px;

            .consent-item {
                padding-right: 15px;

                i {
                    margin-top: 6px;
                    padding-left: 10px;
                    float: right;
                    transition: opacity 0.3s ease-in-out;
                    opacity: 0;

                    &.open-info-box {
                        opacity: 1;
                    }
                }

                .required-message {
                    position: absolute;
                    bottom: 45px;
                    width: 400px;
                    background: white;
                    border-radius: 10px;
                    left: 50%;
                    transform: translate(-50%);
                    filter: drop-shadow(0px 3px 6px #c3c3c3);
                    padding: 15px;

                    i {
                        right: 12px;
                        top: 6px;
                        font-size: 12px;
                        opacity: 1;
                    }

                    p {
                        max-width: none;
                        margin: 0;
                    }

                    &:after {
                        content: "";
                        position: absolute;
                        width: 0;
                        height: 0;
                        border-left: 15px solid transparent;
                        border-right: 15px solid transparent;
                        border-top: 15px solid #fff;
                        right: 0;
                        left: 0;
                        margin: auto;
                        bottom: -15px;
                    }

                    &.info-box {
                        left: auto;
                        transform: none;
                        right: -179px;

                        .info-wrapper {
                            .info-item {
                                border-top: 1px solid #f1f1f1;
                                padding-top: 8px;
                                margin-top: 8px;

                                p {
                                    line-height: 18px;

                                    &.bold-text {
                                        padding-bottom: 3px;
                                    }
                                }

                                &:first-of-type {
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                }
                            }
                        }
                    }
                }

                .cbx {
                    position: relative;
                    top: 1px;
                    width: 17px;
                    height: 17px;
                    border: 1px solid #c8ccd4;
                    border-radius: 3px;
                    vertical-align: middle;
                    transition: background 0.1s ease;
                    cursor: pointer;

                    &:after {
                        content: '';
                        position: absolute;
                        top: 1px;
                        left: 5px;
                        width: 5px;
                        height: 11px;
                        opacity: 0;
                        transform: rotate(45deg) scale(0);
                        border-right: 2px solid #fff;
                        border-bottom: 2px solid #fff;
                        transition: all 0.3s ease;
                        transition-delay: 0.15s;
                    }
                }

                .lbl {
                    font-weight: 400;
                    color: #929292;
                    margin-top: 1px;
                    margin-left: 5px;
                    vertical-align: middle;
                    cursor: pointer;
                }

                .cbx-box:checked ~ .cbx {
                    border-color: transparent;
                    background: #9a9a9a;
                    animation: jelly 0.6s ease;

                    &:after {
                        opacity: 1;
                        transform: rotate(45deg) scale(1);
                    }
                }

                @keyframes jelly {
                    from {
                        transform: scale(1, 1);
                    }

                    30% {
                        transform: scale(1.25, 0.75);
                    }

                    40% {
                        transform: scale(0.75, 1.25);
                    }

                    50% {
                        transform: scale(1.15, 0.85);
                    }

                    65% {
                        transform: scale(.95, 1.05);
                    }

                    75% {
                        transform: scale(1.05, .95);
                    }

                    to {
                        transform: scale(1, 1);
                    }
                }

                &.check-all {
                    float: right;

                    .cbx-box:checked ~ .cbx {
                        background: #6caf51;
                        transition: background 0.2s ease-in-out, transform 0.2s ease-in-out;
                    }

                    .cbx {
                        border: 1px solid #6caf51;
                        transition: border 0.2s ease-in-out, transform 0.2s ease-in-out;
                    }

                    .lbl {
                        font-weight: 600;
                        color: #6caf51;
                        transition: color 0.2s ease-in-out, transform 0.2s ease-in-out, padding 0.2s ease-in-out;
                    }

                    &.highlight-check-all {
                        .cbx-box:checked ~ .cbx {
                            transform: scale(1.1);
                            background: #ff9067;
                        }

                        .cbx {
                            transform: scale(1.1);
                            border: 1px solid #ff9067;
                        }

                        .lbl {
                            padding-left: 5px;
                            transform: scale(1.1);
                            color: #ff9067;
                        }
                    }
                }

                &.required-item {
                    &:after {
                        position: absolute;
                        right: 30px;
                        top: 0px;
                        content: "*";
                        color: #929292;
                    }

                    &.highlight-check-all {
                        &:after {
                            color: #ff9067;
                        }
                    }
                }

                &:hover {
                    i {
                        opacity: 1;
                    }
                }
            }

            .consent-items-wrapper {
                width: 100%;

                .consent-item {
                    &:first-of-type {
                        &:after {
                            border-radius: 5px 0 0 5px;
                        }
                    }

                    &:last-of-type {
                        padding-right: 0;

                        .required-message {
                            &.info-box {
                                right: -193px;
                            }
                        }

                        &:after {
                            border-radius: 0 5px 5px 0;
                        }
                    }
                }
            }
        }

        .cookie-submit {
            margin-bottom: -3px;

            .general-button {
                transition: transform 0.15s ease-in-out;
                transform: scale(1);

                &:before {
                    content: "";
                    position: absolute;
                    border-radius: 3px;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    transition: transform 0.5s ease-in-out, border 0.5s ease-in-out;
                    border: 0px solid transparent;
                    transform: scale3d(1, 1, 1);
                }

                &.animate-button {
                    transform: scale(1.05);

                    &:before {
                        border: 2px solid rgba(45, 128, 115, 0.05);
                        transform: scale3d(1.1, 1.4, 1.1);
                    }
                }
            }
        }
    }

    //required message transition
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s, bottom 0.3s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
        bottom: 35px !important;
    }

    .fade-enter-to, .fade-leave {
        opacity: 1;
        bottom: 45px !important;
    }
</style>